import React, { forwardRef } from 'react';

interface IdCardProps {
  classes?: string;
  style?: React.CSSProperties;
  forwardRef?: React.RefObject<HTMLElement>;
}

export const IdCard = forwardRef<HTMLElement, IdCardProps>(({ classes, style = {}, forwardRef: _ }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-id-card ${classes || ''}`} style={style}></i>
  );
});

IdCard.displayName = 'IdCard';